import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListParams, Res } from "../models";
import { ApiBasicService } from "./api-basic.service";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: 'root'
})

export class ApiProductsService {

  constructor(
    private apiBasic: ApiBasicService,
    private api: ApiService
  ) { }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param params List
   * @returns Observable<Res>
   */
  getList(params: ListParams): Observable<Res> {

    // return this.api.post('product/list_flex', params, 'private');
    return this.api.post('productList', params, 'private', 'files');
  }

  /**
   * 
   * @param params List
   * @returns Observable<Res>
   */
  getProductOperators(params: any): Observable<Res> {

    return this.api.post('getOperators', params, 'private', 'files');
  }

  /**
   * 
   * @param params List
   * @returns Observable<Res>
   */
  getProductForIntegration(id: string): Observable<Res> {

    return this.api.get('getValidProducts', id, 'private', 'files');
  }

  /**
   * 
   * @param params List
   * @returns Observable<Res>
   */
  onIntegrationProducts(methodName, params: any, projectType: string): Observable<Res> {

    return this.api.post(methodName, params, 'private', projectType);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  save(params: any): Observable<Res> {

    return this.apiBasic.create('product', params);
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  createUserAttributesListForDisplay(params: any): Observable<Res> {

    return this.apiBasic.create('configure_attributes', params);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  info(id: string): Observable<Res> {

    return this.apiBasic.getInfo('product', id);
  }


  /**
   * 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('product', params);
  }


  /**
   * 
   * @returns 
   */
  exportFilesVGH(): Observable<Res> {

    return this.apiBasic.getInfo('product');
  }


  /**
   * 
   * @returns 
   */
  productFilterCreate(params): Observable<Res> {

    return this.api.post('productPermissions/create', params, 'private', 'files');
    // return this.apiBasic.create('productPermissions', data);
  }
}